import { getAppValue } from "src/utils/environment";

const dialogContent = {
  unlimitedMonitoringDailyCap: {
    heading: "premium.feature.dailyVideoCap.heading",
    text: "premium.feature.video.text",
    videoName: "freemium-unlimited.mp4"
  },
  unlimitedMonitoring: {
    heading: "premium.feature.video.heading",
    text: "premium.feature.video.text",
    videoName: "freemium-unlimited.mp4"
  },
  soundsAndVideos: {
    heading: "premium.feature.replay.heading",
    text: "premium.feature.replay.text",
    videoName: "freemium-activity-log.mp4"
  },
  record: {
    heading: "premium.feature.record.heading",
    text: "premium.feature.record.text",
    videoName: "freemium-recording.mp4"
  },
  mute: {
    heading: "premium.feature.mute.heading",
    text: "premium.feature.mute.text",
    videoName: "freemium-mute.mp4"
  },
  unlimited: {
    heading: "premium.feature.unlimited.heading",
    text: "premium.feature.unlimited.text",
    imageName: "freemium-devices.svg"
  },
  playAndRecord: {
    heading: `premium.feature.${getAppValue({
      bibino: "lullabies",
      barkio: "commands"
    })}.heading`,
    text: `premium.feature.${getAppValue({
      bibino: "lullabies",
      barkio: "commands"
    })}.text`,
    videoName: `freemium-${getAppValue({
      bibino: "lullabies",
      barkio: "commands"
    })}.mp4`
  },
  everyMove: {
    heading: "premium.feature.move.heading",
    text: "premium.feature.move.text",
    videoName: "freemium-move.mp4"
  },
  events: {
    heading: "premium.feature.events.heading",
    text: "premium.feature.events.text",
    videoName: "freemium-recording.mp4"
  },
  editor: {
    heading: "whatsNew.avatarCustomization.title",
    text: "whatsNew.avatarCustomization.subtitle",
    videoName: "freemium-appearance.mp4"
  },
  multibaby: {
    heading: "premium.multibaby.heading",
    text: "premium.multibaby.subtitle",
    imageName: `freemium-${getAppValue({
      bibino: "multibaby",
      barkio: "multidog"
    })}.svg`
  },
  scheduler: {
    heading: "premium.scheduler.title",
    text: "premium.scheduler.subtitle",
    imageName: "freemium-scheduler.svg"
  },
  photoMode: {
    heading: "premium.monitoringAppearance.title",
    text: "premium.monitoringAppearance.subtitle",
    videoName: "freemium-appearance.mp4"
  }
};

export default dialogContent;
